import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { VehiclesRepository } from '../vehicles.repository';
import { VehiclesApiService } from '../vehicles-api.service';
import { VehiclesApiMockService } from '@mocks/vehicles-api-mock.service';

export const HTTP_VEHICLES_SERVICE = new InjectionToken<VehiclesRepository>('VehiclesRepository');

export const VEHICLES_API_PROVIDER: Provider = {
    provide: HTTP_VEHICLES_SERVICE,
    useClass: environment.useMocks && environment.useMocks.vehicles ? VehiclesApiMockService : VehiclesApiService,
};
